var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocuments = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 1.714a2.57 2.57 0 0 1 2.571 2.572v15.428A2.57 2.57 0 0 1 18 22.286H6a2.57 2.57 0 0 1-2.571-2.572V4.286A2.57 2.57 0 0 1 6 1.714zm0 1.715H6a.857.857 0 0 0-.857.857v15.428c0 .474.384.857.857.857h12a.857.857 0 0 0 .857-.857V4.286A.857.857 0 0 0 18 3.429m-3.429 13.714a.857.857 0 0 0-.857-.857H8.571a.857.857 0 0 0 0 1.714h5.143a.857.857 0 0 0 .857-.857M12 9.429a.857.857 0 1 1 0 1.714H8.571a.857.857 0 0 1 0-1.714zm4.286-2.572A.857.857 0 0 0 15.429 6H8.57a.857.857 0 0 0 0 1.714h6.858a.857.857 0 0 0 .857-.857",
  clipRule: "evenodd"
})));
export default SvgDocuments;